import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
import { ButtonStyles } from '../Buttons/GeneralButton/Button.styles';
const Container = styled.form `
  display: flex;
  flex-wrap: wrap;
  background: ${brand.white};
  border-radius: 4px;

  @media ${until(Device.TabletLarge)} {
    display: grid;
    grid-template-columns: 1fr;
    width: 100%;
  }
`;
const Section = styled.fieldset `
  display: flex;
  border-bottom: 1px solid #efefef;
  flex-direction: column;
  padding: 14px 18px;
  flex: 1 0 15%;

  &:last-child {
    border-bottom: 0;
  }

  &[data-align='top'] {
    justify-content: flex-start;
  }

  &[data-align='center'] {
    justify-content: center;
  }

  &[data-align='bottom'] {
    justify-content: flex-end;
  }

  @media ${from(Device.Tablet)} {
    border-right: 1px solid #efefef;
    padding: 24px 28px;

    &:last-child {
      border-right: 0;
    }
  }
`;
const Label = styled.label `
  ${fonts.sofiaPro.medium}
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 8px;
`;
const Inner = styled.div `
  ${ButtonStyles.Button} {
    width: 100%;
  }
`;
const HorizontalFormStyles = {
    Container,
    Inner,
    Label,
    Section,
};
export default HorizontalFormStyles;
